export const LANGUAGE_LIST = [
    "Python",
    "Javascript",
    "Typescript",
    "Java",
    "Kotlin",
    "Swift",
    "Go",
    "C#",
    "Ruby",
    "Rust",
    "Elixir",
    "C++",
    "C",
    "Zig",
    "Bash",
    "SQL",
    "Godot"
]